import axiosClient from "../api/axios-client";
import { detachCurrentPushSubscription } from "../helpers/webPushSubscription";
import { useSessionTeardown } from "./useSessionTeardown";

export function useLogout() {
    const teardown = useSessionTeardown();

    const logout = async () => {
        // Se déconnecter est une intention : on coupe aussi les notifications de
        // CET appareil. Leur charge utile affiche le nom d'un client et cent
        // caractères de son message sur l'écran verrouillé — sans ce geste, un
        // navigateur dont on s'est déconnecté continue de les recevoir.
        //
        // Avant le POST /logout, jamais après : la suppression de la ligne passe
        // par une route authentifiée.
        try {
            await detachCurrentPushSubscription();
        } catch (_) {
            // Un abonnement récalcitrant ne doit pas retenir quelqu'un qui s'en va.
        }

        try {
            await axiosClient.post("/logout"); // 204 attendu
        } catch (_) {
            // on ignore, on force tout de même la sortie
        } finally {
            teardown();
        }
    };

    return { logout };
}
